// Autogenerated file
export const driverChatInitializeTypesEnum = {
    AllBidParticipants: "AllBidParticipants",
    LogistAndDriver: "LogistAndDriver",
    LogistAndResponsibleAndDriver: "LogistAndResponsibleAndDriver",
};
export const driverChatInitializeTypes = [
    { label: "Все участники заявки", value: "AllBidParticipants" },
    { label: "Логист и водитель", value: "LogistAndDriver" },
    { label: "Логист, ответственный и водитель", value: "LogistAndResponsibleAndDriver" },
];
